import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import { AnimTap, EColors2 } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

interface Props {
    selected: boolean;
    onChange: (value: boolean) => void;
    className?: string;
}

export const GuideBoolean = (props: Props): JSX.Element => {
    return (
        <S_GuideBoolean
            className={props.className}
            onClick={() => {
                props.onChange(!props.selected);
            }}
        >
            <S_Circle $selected={props.selected} {...AnimTap}>
                <S_Icon
                    icon={['far', props.selected ? 'check' : 'xmark']}
                    $selected={props.selected}
                />
            </S_Circle>
        </S_GuideBoolean>
    );
};

const S_GuideBoolean = styled.div`
    width: 80px;
    height: 44px;
    background-color: #fafcfe;
    border: 1px solid #eaf0f5;
    border-radius: 120px;
    position: relative;
    cursor: pointer;
`;

const S_Circle = styled(motion.div)<{ $selected: boolean }>`
    position: absolute;
    top: 2px;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    ${(props) => {
        if (props.$selected) {
            return css`
                right: 2px;
                background-color: ${EColors2.DARK};
                border: 1px solid ${EColors2.DARK};
            `;
        } else {
            return css`
                left: 2px;
                background-color: #fff;
                border: 1px solid ${EColors2.DARK};
            `;
        }
    }}
`;

const S_Icon = styled(FontAwesomeIcon)<{ $selected: boolean }>`
    font-size: 16px;
    color: #fff;
    ${(props) => {
        if (props.$selected) {
            return css`
                color: #fff;
            `;
        } else {
            return css`
                color: ${EColors2.DARK};
            `;
        }
    }}
`;
